import type { GlossaryTermSummary } from '../../services/glossaryService';

const DIFFICULTY_STYLES: Record<string, string> = {
  starter: 'text-teal-400 bg-teal-500/10',
  intermediate: 'text-amber-400 bg-amber-500/10',
  advanced: 'text-red-400 bg-red-500/10',
};

interface Props {
  term: GlossaryTermSummary;
  onClick: () => void;
}

export default function GlossaryCard({ term, onClick }: Props) {
  const diffStyle = term.difficulty_hint ? DIFFICULTY_STYLES[term.difficulty_hint] ?? '' : '';
  const preview = term.definition.length > 100
    ? term.definition.slice(0, 100) + '…'
    : term.definition;

  return (
    <div
      onClick={onClick}
      className="rounded-xl bg-slate-800/70 border border-slate-700/50 p-4 cursor-pointer hover:border-teal-500/50 hover:bg-slate-800 transition-all"
    >
      <div className="flex items-start justify-between gap-2 mb-2">
        <h3 className="font-semibold text-white text-sm leading-snug">{term.term}</h3>
        {term.difficulty_hint && (
          <span className={`text-xs px-2 py-0.5 rounded-full shrink-0 capitalize ${diffStyle}`}>
            {term.difficulty_hint}
          </span>
        )}
      </div>
      <p className="text-slate-400 text-xs leading-relaxed">{preview}</p>
    </div>
  );
}
